(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire6f2c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire6f2c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3sHb8", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $28557b013f37bb6b$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $28557b013f37bb6b$export$1e71eb4bef00f6b0; });
function $28557b013f37bb6b$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


var $3sHb8 = parcelRequire("3sHb8");
var $983b29fbd81669b6$exports = {};
/***
   Copyright 2013 Teun Duynstee

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ $983b29fbd81669b6$exports = function() {
    function identity(v) {
        return v;
    }
    function ignoreCase(v) {
        return typeof v === "string" ? v.toLowerCase() : v;
    }
    function makeCompareFunction(f, opt) {
        opt = typeof opt === "object" ? opt : {
            direction: opt
        };
        if (typeof f != "function") {
            var prop = f;
            // make unary function
            f = function f(v1) {
                return !!v1[prop] ? v1[prop] : "";
            };
        }
        if (f.length === 1) {
            // f is a unary function mapping a single item to its sort score
            var uf = f;
            var preprocess = opt.ignoreCase ? ignoreCase : identity;
            var cmp = opt.cmp || function(v1, v2) {
                return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
            };
            f = function f(v1, v2) {
                return cmp(preprocess(uf(v1)), preprocess(uf(v2)));
            };
        }
        var descTokens = {
            "-1": "",
            desc: ""
        };
        if (opt.direction in descTokens) return function(v1, v2) {
            return -f(v1, v2);
        };
        return f;
    }
    /* adds a secondary compare function to the target function (`this` context)
       which is applied in case the first one returns 0 (equal)
       returns a new compare function, which has a `thenBy` method as well */ function tb(func, opt) {
        /* should get value false for the first call. This can be done by calling the 
        exported function, or the firstBy property on it (for es6 module compatibility)
        */ var x = typeof this == "function" && !this.firstBy ? this : false;
        var y = makeCompareFunction(func, opt);
        var f = x ? function f(a, b) {
            return x(a, b) || y(a, b);
        } : y;
        f.thenBy = tb;
        return f;
    }
    tb.firstBy = tb;
    return tb;
}();


if (window.developerPortal) document.addEventListener("DOMContentLoaded", function() {
    function setLinksOnTable() {
        // data-href link on table row
        var trElements = document.querySelectorAll("tr[data-href]");
        trElements.forEach(function(el) {
            el.addEventListener("click", function() {
                window.location = el.getAttribute("data-href");
                return false;
            });
        });
    }
    if (!window.developerPortal.countries) console.log("No countries supplied for plugin.");
    if (!window.developerPortal.paymentProducts) console.log("No payment products supplied for plugin.");
    if (!window.developerPortal.paymentMethods) console.log("No payment methods supplied for plugin.");
    if (!Array.prototype.find) Object.defineProperty(Array.prototype, "find", {
        value: function value(predicate) {
            if (this == null) throw new TypeError('"this" is null or not defined');
            var o = Object(this);
            var len = o.length >>> 0;
            if (typeof predicate !== "function") throw new TypeError("predicate must be a function");
            var thisArg = arguments[1];
            var k = 0;
            while(k < len){
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) return kValue;
                k++;
            }
            return undefined;
        }
    });
    var _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    var countries = window.developerPortal.countries;
    var paymentProducts = window.developerPortal.paymentProducts;
    var paymentMethods = window.developerPortal.paymentMethods;
    var amountOfPaymentProductsToDisplayBeforeShowMore = 9999;
    var loadMoreIncrement = 9999;
    function getPaymentMethodName(paymentMethodCode) {
        var matchingPaymentMethod = paymentMethods.find(function(element) {
            return element.code === paymentMethodCode;
        });
        if (matchingPaymentMethod) return matchingPaymentMethod.name;
    }
    function getPaymentProductInfo(paymentProduct) {
        var matchingPaymentProduct = paymentProducts.find(function(element) {
            return element.code === paymentProduct.code;
        });
        if (matchingPaymentProduct) {
            paymentProduct["paymentMethod"] = getPaymentMethodName(matchingPaymentProduct.paymentMethodCode);
            paymentProduct["name"] = matchingPaymentProduct.name;
            paymentProduct["logo"] = matchingPaymentProduct.logo;
            return true;
        } else return false;
    }
    function getCountriesGroupValues(countries) {
        countries.forEach(function(country, index) {
            var emptyPaymentProducts = [];
            countries[index].paymentProducts.forEach(function(paymentProduct, paymentProductIndex) {
                if (!getPaymentProductInfo(countries[index].paymentProducts[paymentProductIndex])) emptyPaymentProducts.push(paymentProductIndex);
            });
            // Remove payment products from country that have no data
            for(var i = 0; i < emptyPaymentProducts.length; emptyPaymentProducts++)countries[index].paymentProducts.splice(emptyPaymentProducts[i], 1);
            countries[index].relevance = index;
            countries[index].type = "country";
            countries[index].rowsVisible = amountOfPaymentProductsToDisplayBeforeShowMore;
            countries[index].prevalencePopoverVisible = false;
            countries[index].popoverVisible = false;
            countries[index].sortType = "prevalence";
            countries[index].sortOrderPrevalence = "desc";
            if (countries[index].paymentProducts) sortByProperty(countries[index].paymentProducts, "prevalence", -1, "name");
        });
        return countries;
    }
    function getPaymentMethodGroupValues(paymentMethods) {
        paymentMethods.forEach(function(paymentMethod, index) {
            paymentMethods[index] = paymentMethod;
            paymentMethods[index].paymentMethodCode = paymentMethods[index].code;
            paymentMethods[index].code = "PM-" + paymentMethods[index].code;
            paymentMethods[index].initialOrder = index;
            paymentMethods[index].type = "payment-method";
        });
        return paymentMethods;
    }
    function getPaymentProductGroupValues(paymentMethods) {
        paymentMethods.forEach(function(paymentMethod, index) {
            paymentMethods[index] = paymentMethod;
            paymentMethods[index].initialOrder = index;
            paymentMethods[index].type = "payment-product";
        });
        return paymentMethods;
    }
    var options = [
        {
            "groupLabel": window.developerPortal.translations.country,
            "groupCode": "country",
            "groupValues": getCountriesGroupValues(countries)
        },
        {
            "groupLabel": window.developerPortal.translations.paymentMethod,
            "groupCode": "payment-method",
            "groupValues": getPaymentMethodGroupValues(paymentMethods)
        },
        {
            "groupLabel": window.developerPortal.translations.paymentProduct,
            "groupCode": "payment-product",
            "groupValues": getPaymentProductGroupValues(paymentProducts)
        }
    ];
    function capitalize(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    var paymentMethodOptions = options.find(function(element) {
        return element.groupCode === "payment-method";
    });
    var paymentProductOptions = options.find(function(element) {
        return element.groupCode === "payment-product";
    });
    function sortByProperty(array, propertyName, reversed) {
        if (propertyName === "paymentMethodCode") return array.sort((0, $983b29fbd81669b6$exports.firstBy)(function(v1, v2) {
            var v1Name = "";
            var v2Name = "";
            paymentMethodOptions.groupValues.find(function(element) {
                if (element.paymentMethodCode === v1.paymentMethodCode) v1Name = element.name.toLowerCase();
            });
            paymentMethodOptions.groupValues.find(function(element) {
                if (element.paymentMethodCode === v2.paymentMethodCode) v2Name = element.name.toLowerCase();
            });
            if (v1Name < v2Name) return -1;
            if (v1Name > v2Name) return 1;
        }, {
            ignoreCase: true,
            direction: reversed
        }).thenBy(function(v1, v2) {
            return v1.code.localeCompare(v2.code);
        }));
        else return array.sort((0, $983b29fbd81669b6$exports.firstBy)(propertyName, {
            ignoreCase: true,
            direction: reversed
        }));
    }
    paymentMethodOptions.groupValues = sortByProperty(paymentMethodOptions.groupValues, "initialOrder");
    paymentProductOptions.groupValues = sortByProperty(paymentProductOptions.groupValues, "name");
    var defaultOptions = [];
    function getQueryParameter(key) {
        key = key.replace(/[*+?^$.\[\]{}()|\\\/]/g, "\\$&"); // escape RegEx meta chars
        var match = location.search.match(new RegExp("[?&]" + key + "=([^&]+)(&|$)"));
        return match && decodeURIComponent(match[1].replace(/\+/g, " "));
    }
    var countryParameters = getQueryParameter("country");
    var paymentMethodParameters = getQueryParameter("payment-method");
    var paymentProductParameters = getQueryParameter("payment-product");
    // Set the default options based on URL parameters
    if (countryParameters) {
        countryParameters = countryParameters.split("|");
        function filterByCode(item) {
            //return jQuery.inArray(item.code, countryParameters) >= 0;
            return countryParameters.includes(item.code);
        }
        var combinedOptions = defaultOptions.concat(countryOptions.groupValues.filter(filterByCode));
        var allOptionsUnique = removeDuplicates(combinedOptions, "name");
        defaultOptions = allOptionsUnique;
    }
    if (paymentMethodParameters) {
        paymentMethodParameters = paymentMethodParameters.split("|");
        function filterByCode(item) {
            //return jQuery.inArray(item.paymentMethodCode, paymentMethodParameters) >= 0;
            return paymentMethodParameters.includes(item.paymentMethodCode);
        }
        defaultOptions = defaultOptions.concat(paymentMethodOptions.groupValues.filter(filterByCode));
    }
    if (paymentProductParameters) {
        paymentProductParameters = paymentProductParameters.split("|");
        function filterByPaymentProductCode(item) {
            //return jQuery.inArray(item.code, paymentProductParameters) >= 0;
            return paymentProductParameters.includes(item.code);
        }
        defaultOptions = defaultOptions.concat(paymentProductOptions.groupValues.filter(filterByPaymentProductCode));
    }
    function removeDuplicates(itemsArray, prop) {
        return itemsArray.filter(function(obj, pos, arr) {
            return arr.map(function(mapObj) {
                return mapObj[prop];
            }).indexOf(obj[prop]) === pos;
        });
    }
    function removeURLParameter(url, parameter) {
        var urlparts = url.split("?");
        if (urlparts.length >= 2) {
            var prefix = encodeURIComponent(parameter) + "=";
            var pars = urlparts[1].split(/[&;]/g);
            for(var i = pars.length; i-- > 0;)if (pars[i].lastIndexOf(prefix, 0) !== -1) pars.splice(i, 1);
            url = urlparts[0] + (pars.length > 0 ? "?" + pars.join("&") : "");
            return url;
        } else return url;
    }
    function updateQueryString(key, value, url) {
        if (!url) url = window.location.href;
        var re = new RegExp("([?&])" + key + "=.*?(&|#|$)(.*)", "gi"), hash;
        if (re.test(url)) {
            if (typeof value !== "undefined" && value !== null) return url.replace(re, "$1" + key + "=" + value + "$2$3");
            else {
                hash = url.split("#");
                url = hash[0].replace(re, "$1$3").replace(/(&|\?)$/, "");
                if (typeof hash[1] !== "undefined" && hash[1] !== null) url += "#" + hash[1];
                return url;
            }
        } else {
            if (typeof value !== "undefined" && value !== null) {
                var separator = url.indexOf("?") !== -1 ? "&" : "?";
                hash = url.split("#");
                url = hash[0] + separator + key + "=" + value;
                if (typeof hash[1] !== "undefined" && hash[1] !== null) url += "#" + hash[1];
                return url;
            } else return url;
        }
    }
    window.Vue.component("multiselect", window.VueMultiselect);
    window.Vue.config.devtools = true;
    var _obj;
    new window.Vue({
        name: "paymentMethods",
        el: "#paymentmethods",
        computed: {
            filteredCountries: function filteredCountries() {
                var that = this;
                var combinedOptions = [];
                var _$countryOptions = this.getCountryOptions();
                var paymentProductOptions = this.getPaymentProductProductOptions();
                var paymentProductsToDisplay = [];
                var hasCountriesSelected = false;
                if (this.selectedOptions.length > 0) {
                    // Populate list of payment products for filtering
                    for(var optionIndex = 0; optionIndex < this.selectedOptions.length; optionIndex++){
                        var selectedOption = this.selectedOptions[optionIndex];
                        if (selectedOption && selectedOption.type === "payment-product") paymentProductsToDisplay.push(selectedOption.code);
                    }
                    for(var optionIndex = 0; optionIndex < this.selectedOptions.length; optionIndex++){
                        var selectedOption = this.selectedOptions[optionIndex];
                        if (selectedOption) {
                            if (selectedOption.type === "continent") for(var countryIndex = 0; countryIndex < _$countryOptions.length; countryIndex++){
                                var country = _$countryOptions[countryIndex];
                                //if (jQuery.inArray(selectedOption.continentCode, country.continentCodes) >= 0) {
                                if (country.continentCodes.includes(selectedOption.continentCode)) {
                                    combinedOptions.push(country);
                                    hasCountriesSelected = true;
                                }
                            }
                            else if (selectedOption.type === "country") {
                                var selectedOptionCode = selectedOption.code;
                                var selectedOptionCountry = _$countryOptions.find(function(element) {
                                    return element.code === selectedOptionCode;
                                });
                                combinedOptions.push(selectedOptionCountry);
                                hasCountriesSelected = true;
                            }
                        }
                    }
                    for(var optionIndex = 0; optionIndex < this.selectedOptions.length; optionIndex++){
                        var selectedOption = this.selectedOptions[optionIndex];
                        if (selectedOption) {
                            if (selectedOption.type === "payment-method") {
                                for(var i = 0; i < paymentProductOptions.length; i++)if (paymentProductOptions[i].paymentMethodCode === selectedOption.paymentMethodCode) paymentProductsToDisplay.push(paymentProductOptions[i].code);
                            }
                            if (selectedOption.type === "payment-product" || selectedOption.type === "payment-method") {
                                if (!hasCountriesSelected) // Find in all countries
                                for(var countryIndex = 0; countryIndex < _$countryOptions.length; countryIndex++){
                                    var country = _$countryOptions[countryIndex];
                                    var countryHasPaymentProduct = false;
                                    countryHasPaymentProduct = country.paymentProducts.find(function(element) {
                                        //return jQuery.inArray(element.code, paymentProductsToDisplay) >= 0;
                                        return paymentProductsToDisplay.includes(element.code);
                                    });
                                    if (countryHasPaymentProduct) combinedOptions.push(country);
                                }
                                else {
                                    var combinedOptionsIndex = combinedOptions.length;
                                    // Find in only the selected countries
                                    while(combinedOptionsIndex--){
                                        var country = combinedOptions[combinedOptionsIndex];
                                        var removeCountry = true;
                                        for(var productsIndex = 0; productsIndex < country.paymentProducts.length; productsIndex++)//if (jQuery.inArray(country.paymentProducts[productsIndex].code, paymentProductsToDisplay) >= 0) {
                                        if (paymentProductsToDisplay.includes(country.paymentProducts[productsIndex].code)) {
                                            removeCountry = false;
                                            break;
                                        } else removeCountry = true;
                                        if (removeCountry) combinedOptions.splice(combinedOptionsIndex, 1);
                                    }
                                }
                            }
                            if (paymentProductsToDisplay.length > 0) for(var productIndex = 0; productIndex < combinedOptions.length; productIndex++){
                                var selectedOptionCountryToDisplay = _$countryOptions.find(function(element) {
                                    return element.code === combinedOptions[productIndex].code;
                                });
                                // Remove individual payment products that are not available on the chosen platform
                                combinedOptions[productIndex] = _extends({}, selectedOptionCountryToDisplay, {
                                    paymentProducts: selectedOptionCountryToDisplay.paymentProducts.filter(function(product) {
                                        //return jQuery.inArray(product.code, paymentProductsToDisplay) >= 0;
                                        return paymentProductsToDisplay.includes(product.code);
                                    })
                                });
                            }
                        }
                    }
                } else combinedOptions = _$countryOptions;
                //add payment product id to combinedoptions
                combinedOptions.forEach(function(option) {
                    option.paymentProducts.forEach(function(product) {
                        paymentProductOptions.find(function(element) {
                            if (element.code === product.code) product.paymentId = element.paymentId;
                        });
                    });
                });
                combinedOptions = removeDuplicates(combinedOptions, "code");
                combinedOptions = removeDuplicates(combinedOptions, "name");
                if (that.filteredPlatform) {
                    // Remove all countries that have no platforms selected by the platform filter
                    combinedOptions = combinedOptions.filter(function(item) {
                        for(var i = 0; i < item.paymentProducts.length; i++){
                            var platform = item.paymentProducts[i].paymentPlatforms.find(function(element) {
                                return element.name === that.filteredPlatform;
                            });
                            if (platform !== undefined) return true;
                        }
                    });
                    for(var i = 0; i < combinedOptions.length; i++){
                        var selectedOptionCountry = _$countryOptions.find(function(element) {
                            return element.code === combinedOptions[i].code;
                        });
                        // Remove individual payment products that are not available on the chosen platform
                        combinedOptions[i] = _extends({}, selectedOptionCountry, {
                            paymentProducts: selectedOptionCountry.paymentProducts.filter(function(item) {
                                var hasPlatform = false;
                                for(var a = 0; a < item.paymentPlatforms.length; a++)if (item.paymentPlatforms[a].name === that.filteredPlatform) hasPlatform = true;
                                if (hasPlatform && paymentProductsToDisplay.length > 0) //return jQuery.inArray(item.code, paymentProductsToDisplay) >= 0;
                                return paymentProductsToDisplay.includes(item.code);
                                return hasPlatform;
                            })
                        });
                        // If a different payment platform is chosen filtering for prevalence has to be recalculated
                        if (combinedOptions[i].sortType === "prevalence" && that.filteredPlatform) combinedOptions[i].paymentProducts = sortByProperty(combinedOptions[i].paymentProducts, function(v1, v2) {
                            var v1platform = v1.paymentPlatforms.find(function(element) {
                                return element.name === that.filteredPlatform;
                            });
                            var v2platform = v2.paymentPlatforms.find(function(element) {
                                return element.name === that.filteredPlatform;
                            });
                            if (v1platform && v2platform) return v1platform.prevalence - v2platform.prevalence;
                        }, combinedOptions[i].sortOrderPrevalence === "asc" ? undefined : -1);
                    }
                }
                return combinedOptions;
            },
            totalCountriesCount: function totalCountriesCount() {
                var _$countryOptions = this.options.find(function(element) {
                    return element.groupCode === "country";
                });
                if (_$countryOptions.groupValues) return _$countryOptions.groupValues.length;
            },
            selectedOptionsWithPaymentProductsLinkedToPaymentMethods: function selectedOptionsWithPaymentProductsLinkedToPaymentMethods() {
                var combinedOptions = [];
                var that = this;
                var paymentProductOptions = this.options.find(function(element) {
                    return element.groupCode === "payment-product";
                });
                function removeDuplicates(myArr, prop) {
                    return myArr.filter(function(obj, pos, arr) {
                        return arr.map(function(mapObj) {
                            return mapObj[prop];
                        }).indexOf(obj[prop]) === pos;
                    });
                }
                if (this.selectedOptions.length > 0) for(var optionIndex = 0; optionIndex < this.selectedOptions.length; optionIndex++){
                    var selectedOption = this.selectedOptions[optionIndex];
                    if (selectedOption.type === "payment-method") for(var countryIndex = 0; countryIndex < paymentProductOptions.groupValues.length; countryIndex++){
                        var country = paymentProductOptions.groupValues[countryIndex];
                        if (selectedOption.paymentMethodCode === country.paymentMethodCode) combinedOptions.push(country);
                    }
                    else combinedOptions.push(selectedOption);
                }
                else combinedOptions = paymentProductOptions.groupValues;
                combinedOptions = removeDuplicates(combinedOptions, "name");
                if (this.sortType) {
                    if (this["sortOrder" + capitalize(this.sortType)] === "desc") combinedOptions = sortByProperty(combinedOptions, this.sortType === "paymentMethod" ? "paymentMethodCode" : this.sortType, -1);
                    else combinedOptions = sortByProperty(combinedOptions, this.sortType === "paymentMethod" ? "paymentMethodCode" : this.sortType);
                } else combinedOptions = sortByProperty(combinedOptions, "paymentMethodCode", false);
                if (this.filteredPlatform) // Remove all payment products that do not match the platform filter
                combinedOptions = combinedOptions.filter(function(item) {
                    var hasPlatform = false;
                    if (item.paymentPlatforms && item.paymentPlatforms.length > 0) {
                        for(var i = 0; i < item.paymentPlatforms.length; i++)if (item.paymentPlatforms[i] === that.filteredPlatform) hasPlatform = true;
                    }
                    return hasPlatform;
                });
                this.lastSortedOn = this.sortType;
                // remove countries from methods
                combinedOptions = combinedOptions.filter(function(option) {
                    return option.type !== "country";
                });
                return combinedOptions;
            },
            totalPaymentProductCount: function totalPaymentProductCount() {
                var paymentProductOptions = this.options.find(function(element) {
                    return element.groupCode === "payment-product";
                });
                if (paymentProductOptions.groupValues) return paymentProductOptions.groupValues.length;
            }
        },
        methods: (_obj = {
            getNamedPrevalence: function getNamedPrevalence(name, data) {
                var prevalence = "";
                for(var i = 0; i < data.length; i++)if (data[i].name === name) prevalence = data[i].prevalence;
                return (parseInt(prevalence) || 0) * 20;
            },
            searchChange: function searchChange(searchQuery) {
                this.searchQuery = searchQuery;
                var matchingCountries = countries.filter(function(item) {
                    return item.name.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1;
                });
                if (matchingCountries && searchQuery) this.matchingCountries = matchingCountries;
                else this.matchingCountries = undefined;
            },
            updateResults: function updateResults(value) {
                this.showCountryOverview = value.some(function(entry) {
                    return entry.type === "country";
                });
            },
            clearAll: function clearAll() {
                if (history.replaceState) history.replaceState(null, null, location.href.split("?")[0]);
                this.filteredPlatform = "";
                this.itemsVisible = loadMoreIncrement;
                this.selectedOptions = [];
                this.urlParametersCountry = "";
                this.urlParametersPaymentMethod = "";
                this.urlParametersPaymentProduct = "";
            },
            getPaymentMethodNameByCode: function getPaymentMethodNameByCode(code) {
                var paymentMethodOptions = this.options.find(function(element) {
                    return element.groupCode === "payment-method";
                });
                var paymentMethod = paymentMethodOptions.groupValues.find(function(paymentMethod) {
                    return paymentMethod.paymentMethodCode === code;
                });
                if (paymentMethod) return paymentMethod.name ? paymentMethod.name : "";
            },
            setPrevalencePopover: function setPrevalencePopover(option) {
                var _$countryOptions = this.getCountryOptions();
                for(var i = 0; i < _$countryOptions.length; i++)if (_$countryOptions[i].code === option.code) {
                    if (_$countryOptions[i].prevalencePopoverVisible) _$countryOptions[i].prevalencePopoverVisible = false;
                    else _$countryOptions[i].prevalencePopoverVisible = true;
                }
            },
            setPopover: function setPopover(option) {
                var _$countryOptions = this.getCountryOptions();
                for(var i = 0; i < _$countryOptions.length; i++)if (_$countryOptions[i].code === option.code) {
                    if (_$countryOptions[i].popoverVisible) _$countryOptions[i].popoverVisible = false;
                    else _$countryOptions[i].popoverVisible = true;
                }
            },
            getCountryOptions: function getCountryOptions() {
                return this.options.find(function(element) {
                    return element.groupCode === "country";
                }).groupValues;
            },
            getPaymentProductProductOptions: function getPaymentProductProductOptions() {
                return this.options.find(function(element) {
                    return element.groupCode === "payment-product";
                }).groupValues;
            },
            sortPaymentProductsCountries: function sortPaymentProductsCountries(option, type) {
                var _$countryOptions = this.getCountryOptions();
                for(var i = 0; i < _$countryOptions.length; i++)if (_$countryOptions[i].code === option.code) {
                    _$countryOptions[i].sortType = type;
                    if (this.lastSortedOn === type && option["sortOrder" + capitalize(type)] === "asc") {
                        _$countryOptions[i].paymentProducts = sortByProperty(_$countryOptions[i].paymentProducts, type, -1);
                        _$countryOptions[i]["sortOrder" + capitalize(type)] = "desc";
                    } else {
                        _$countryOptions[i].paymentProducts = sortByProperty(_$countryOptions[i].paymentProducts, type);
                        _$countryOptions[i]["sortOrder" + capitalize(type)] = "asc";
                    }
                }
                this.lastSortedOn = type;
            },
            sortPaymentProducts: function sortPaymentProducts(type) {
                this.sortType = type;
                if (this.lastSortedOn === this.sortType && this["sortOrder" + capitalize(type)] === "asc") this["sortOrder" + capitalize(type)] = "desc";
                else this["sortOrder" + capitalize(type)] = "asc";
            },
            sortCountries: function sortCountries(type, name) {
                this.countriesSortOrderType = type;
                this.countriesSortOrderName = name;
            }
        }, (0, $3sHb8._)(_obj, "setPopover", function setPopover() {
            if (this.platformPopoverVisible) this.platformPopoverVisible = false;
            else this.platformPopoverVisible = true;
        }), (0, $3sHb8._)(_obj, "suggestionGetsFocus", function suggestionGetsFocus(index) {
            if (index === 0) {
                jQuery(".multiselect__content-wrapper").addClass("always-open");
                jQuery(".first-gets-focus").first().focus();
            }
        }), (0, $3sHb8._)(_obj, "suggestionGetsBlur", function suggestionGetsBlur(event) {
            if (!jQuery(event.relatedTarget).hasClass("first-gets-focus")) jQuery(".multiselect__content-wrapper").removeClass("always-open");
        }), (0, $3sHb8._)(_obj, "closeDropdown", function closeDropdown() {
            var that = this;
            setTimeout(function() {
                if (that.$emit().$children[0].isOpen) that.$emit().$children[0].toggle();
            });
        }), _obj),
        data: function data() {
            return {
                itemsVisible: loadMoreIncrement,
                amountOfPaymentProductsToDisplayBeforeShowMore: amountOfPaymentProductsToDisplayBeforeShowMore,
                selectedOptions: defaultOptions,
                options: options,
                matchingCountries: [],
                sortType: "name",
                sortOrderName: "asc",
                sortOrderCountries: "",
                sortOrderPaymentMethod: "",
                sortOrderPaymentPlatforms: "",
                filteredPlatform: getQueryParameter("platform") ? getQueryParameter("platform") : "",
                platformPopoverVisible: false,
                showCountryOverview: false,
                selectedTags: []
            };
        },
        mounted: function() {
            setLinksOnTable();
        },
        updated: function() {
            setLinksOnTable();
        }
    });
});

})();
//# sourceMappingURL=paymentmethods.js.map
